import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RotateCcw, Pencil } from "lucide-react";
import { http, formatApiError } from "../../lib/api";
import { toast } from "../../lib/notify";

// Reddedilen Ekstra talebi: tek tıkla yeniden GM onayına gönder ya da Veri Girişi'nde düzeltip kaydedince otomatik yeniden gönder (?yeniden=1)
export function ResubmitButtons({ e, onDone, big = false }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!e.flow || e.approval_status !== "rejected") return null;
  const resubmit = async () => {
    if (!window.confirm(`${e.location_name} — ${e.service_name}: talep değiştirilmeden yeniden GM onayına gönderilsin mi?`)) return;
    setBusy(true);
    try {
      const { data } = await http.post(`/entries/${e.id}/resubmit`);
      toast.success(`Talep yeniden GM onayına gönderildi${data.mailed ? ` · ${data.mailed} GM yetkilisine e-posta` : ""}`);
      window.dispatchEvent(new Event("approvals-changed"));
      onDone?.();
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  const cls = big ? "flex items-center justify-center gap-2 h-11 rounded-lg font-bold text-sm" : "inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-[11px] font-bold";
  return (
    <div className={big ? "grid grid-cols-2 gap-2" : "inline-flex items-center gap-1 flex-wrap"} data-testid={`resubmit-actions-${e.id}`}>
      <button type="button" onClick={resubmit} disabled={busy} data-testid={`appr-resubmit-${e.id}`} title="Kaydı değiştirmeden yeniden GM onayına gönder" className={`${cls} bg-emerald-700 text-white hover:bg-emerald-800 disabled:opacity-50`}><RotateCcw className={big ? "w-4 h-4" : "w-3.5 h-3.5"} /> Yeniden Gönder</button>
      <button type="button" onClick={() => navigate(`/veri-girisi?bolum=hizmet&duzenle=${e.id}&yeniden=1`)} data-testid={`appr-edit-resubmit-${e.id}`} title="Veri Girişi'nde düzelt — Güncelle deyince talep otomatik yeniden GM onayına gider" className={`${cls} border border-emerald-600 text-emerald-800 bg-white hover:bg-emerald-50`}><Pencil className={big ? "w-4 h-4" : "w-3.5 h-3.5"} /> Düzelt &amp; Yeniden Gönder</button>
    </div>
  );
}
